import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";

// Point 4: global "No internet connection" banner shown whenever the device is offline.
export default function OfflineBanner() {
  const [offline, setOffline] = useState(typeof navigator !== "undefined" && !navigator.onLine);

  useEffect(() => {
    const goOnline = () => setOffline(false);
    const goOffline = () => setOffline(true);
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, []);

  if (!offline) return null;

  return (
    <div
      data-testid="offline-banner"
      className="fixed top-0 left-0 right-0 z-[200] bg-red-600 text-white px-4 py-2.5 flex items-center justify-center gap-2 text-sm font-semibold shadow-lg animate-in fade-in slide-in-from-top duration-300"
    >
      <WifiOff className="w-4 h-4 flex-shrink-0" />
      No internet connection. Please check your network.
    </div>
  );
}
